export function getView(value) {
  if (value.is_patient) return 'Patient'
  if (value.is_employee) return 'Employee'
  if (value.is_external_professional) return 'ExternalProfessional'
  if (value.is_payer) return 'Payer'
  return 'No'
}
